import React, {
  useEffect, useRef, useState,
} from 'react';

import './VerticalScroller.scss';

interface Props {
  children: React.ReactNode;
}

const VerticalScroller = ({ children }: Props): React.ReactElement => {
  // variables and state
  const [scrollTopValue, setScrollTopValue] = useState(0);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);
  const contentElement = useRef<HTMLDivElement>(null);

  // Keep the scroll position state up to date
  useEffect(() => {
    const { current } = contentElement;

    const onScroll = () => {
      if (current) {
        setScrollTopValue(current.scrollTop);
      }
    };

    if (current) {
      current.addEventListener('scroll', onScroll);
    }

    return () => {
      if (current) {
        current.removeEventListener('scroll', onScroll);
      }
    };
  }, [contentElement.current]);

  // Determine if scrolling is required when the scroll position or el reference updates.
  useEffect(() => {
    const { current } = contentElement;

    if (current) {
      const {
        scrollHeight, offsetHeight,
      } = current;

      setCanScrollDown(scrollHeight - offsetHeight > scrollTopValue);
      setCanScrollUp(scrollTopValue > 0);
    }
  }, [scrollTopValue]);

  return (
    <div className="vertical-scroller">
      <div className={`vertical-scroller-signifier ${canScrollUp && 'on'}`} />

      <div
        className="vertical-scroller-inner"
        ref={contentElement}
      >
        { children }
      </div>

      <div className={`vertical-scroller-signifier ${canScrollDown && 'on'}`} />
    </div>
  );
};

export default VerticalScroller;
